import React__default from 'react';
import { u as useCreateChannelContext } from '../../CreateChannelProvider-ddfd92e6.js';
import InviteMembers from './InviteMembers.js';
import SelectChannelType from './SelectChannelType.js';
import '../../sendBirdSelectors.js';
import '../../topics-17d99dd6.js';
import '../../useSendbirdStateContext.js';
import '../../withSendBird.js';
import '../../_rollupPluginBabelHelpers-8e4fae98.js';
import '../../tslib.es6-83aa13f5.js';
import '../../LocalizationContext-b021af8f.js';
import '../../stringSet-91746bf1.js';
import '../../index-353f13f3.js';
import '../../ui/Modal.js';
import 'prop-types';
import 'react-dom';
import '../../index-1fd114b0.js';
import '../../ui/IconButton.js';
import '../../ui/Icon.js';
import '../../index-41a6f4f2.js';
import '../../index-a611bd38.js';
import '../../utils-9ef11656.js';
import '../../ui/UserListItem.js';
import '../../UserProfileContext-daa99f9b.js';
import '../../ui/Avatar.js';
import '../../ui/ImageRenderer.js';
import '../../uuid-6d14d007.js';
import '../../ui/MutedAvatarOverlay.js';
import '../../ui/Checkbox.js';
import '../../ui/UserProfile.js';
import '../../ui/ContextMenu.js';
import '../../index-ad4c9e58.js';
import '../../ui/SortByRow.js';

var CreateChannel = function CreateChannel(props) {
  var _onCancel = props.onCancel,
      renderStepOne = props.renderStepOne;
  var createChannelProps = useCreateChannelContext();
  var step = createChannelProps.step,
      setStep = createChannelProps.setStep;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, step === 0 && ((renderStepOne === null || renderStepOne === void 0 ? void 0 : renderStepOne()) || /*#__PURE__*/React__default.createElement(SelectChannelType, {
    onCancel: _onCancel
  })), step === 1 && /*#__PURE__*/React__default.createElement(InviteMembers, {
    onCancel: function onCancel() {
      setStep(0);

      _onCancel();
    }
  }));
};

export { CreateChannel as default };